// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"AdFolderForm_dialogContent_Hs3j5","dialogImg":"AdFolderForm_dialogImg_ROgsJ"};